import { gql } from '@apollo/client';

export const DEALERS_BY_MARKET = gql`
  query DealersByMarket($market: Market!) {
    dealersByMarket(market: $market) {
      dealers {
        name
        requestServiceEn
        requestServiceFr
        city
        region
      }
    }
  }
`;
